/**
 * Custom Site Specific Javascript
 *
 * This file is to add custom features to the website without having to modify
 * core/common assets. Define a custom class, and build new or overwrite
 * existing methods to create custom functionality. 
 */
import { SubmitClaim } from 'commonAssets/components/Forms/SubmitClaim';
import { createElement, loadingGif, modal } from 'commonAssets/js/helpers';
import { i18n, outputDiv } from 'commonAssets/js/constants';
import { ErrorHandler } from 'commonAssets/utils/ErrorHandler';

/**
 * Initializes a claim object.
 *
 * @param {Object} claim - The claim object to be initialized.
 * @returns {Object} The initialized claim object.
 */
export function customInitClaim(claim) {
    console.log('[Initiate claim]...');
    // custom code goes here
    // console.log(claim)
    const FIRST_NAME = document.querySelector('input[name="first_name"]');
    const LAST_NAME = document.querySelector('input[name="last_name"]');

    document.querySelector("#claimFieldsTitle").classList.add('d-none');

    document.querySelector("#contact-information").classList.remove('border', 'rounded', 'mb-5');
    document.querySelector("#contact-information").classList.add('border-start', 'border-top', 'border-end', 'rounded-top');

    document.querySelector("#claim-fields").classList.remove('border', 'rounded', 'mb-5');
    document.querySelector("#claim-fields").classList.add('border-start', 'border-bottom', 'border-end', 'rounded-bottom', 'mb-5');

    /**
     * Known Class Members
     */
    // if (claim.data.zero_zero_id) {
    //     FIRST_NAME.disabled = true;
    //     LAST_NAME.disabled = true;
    // }

    return claim;
}

/**
 * Custom function to load a member.
 *
 * @param {Object} claim - The member object to be loaded.
 * @returns {Object} - The loaded member object.
 */
export function customLoadMember(claim) {
    console.log('[Load class member]...');
    // custom code goes here
    return claim;
}

/**
 * Processes a claim for a custom member.
 *
 * @param {Object} claim - The claim to be processed.
 * @returns {Object} The processed claim.
 */
export function customProcessClaim(claim) {
    console.log('[Process claim]...');
    // custom code goes here
    return claim;
}

export class CustomSubmitClaim extends SubmitClaim {

    init_claim_inputs() {
        let claimInputsContact = '#full_name, #first_name, #middle_initial, #last_name, #title, #business_name, #street_address_1, #street_address_2, #country, #city, #state, #zip_code, #province, #postal_code, #email_address, #confirm_email_address, #phone_number_1, #phone_number_2, #signature, #date, #ssn, #referer_url, #user_language, #ag_SGUID, #ag_TEST';
        let claimInputsFields = '#claim-fields input, #claim-fields textarea, #claim-fields select, #alias';
        let claimInputsFieldsPayment = '#payment_method, #payment_token, #payment_email, #payment_phone';
        let claimInputsTransactions = '#transactions input, #transactions textarea, #transactions select';

        this.claim.inputs.contact = Array.from(document.querySelectorAll(claimInputsContact));
        this.claim.inputs.fields = Array.from(document.querySelectorAll(claimInputsFields + ', ' + claimInputsFieldsPayment));
        this.claim.inputs.transactions = Array.from(document.querySelectorAll(claimInputsTransactions));
    }

    claim_confirmation(params) {
        console.log('[claim_confirmation]');
        let correlation_id = params.confirmation.claim_details.correlation_id;
        const confirmation = createElement("div", {
            class: "bg-light text-dark border rounded p-3 mb-3",
            id: "confirmation",
        }, [
            createElement("h3", { class: "text-center mb-3" }, [], params.confirmation['title']),
            createElement("h4", { class: "alert alert-success text-center mb-3" }, [], i18n.getTranslation('confirmation_this_is_a_copy')),
            createElement("p", { class: "text-center text-danger mb-3" }, [], params.confirmation.upload_fail),
            createElement("p", { class: "text-center fw-bold mb-3" }, [], params.confirmation.print_note),
            createElement("h4", { class: "text-center fw-bold mb-3" }, [], params.confirmation.claim_details.title),
            createElement("p", { class: "text-center fw-bold mb-3" }, [], params.confirmation.claim_details.body),
            this.confirmation_claim_member(params),
            this.confirmation_claim_fields(params),
            this.confirmation_claim_transactions(params),
            createElement("div", {
                class: "row mb-3"
            }, correlation_id ? [
                createElement("div", { class: "col-6 text-end fw-bold" }, [], 'Correlation ID'),
                createElement("div", { class: "col-6", id: "confirmation_correlation_id" }, [], params.confirmation.claim_details.correlation_id),
            ] : []),
            createElement("p", { class: "text-center mb-3" }, [], params.confirmation.claim_details.footer),
            createElement("p", { class: "text-center mb-3" }, [], params.confirmation.claim_details.edit),
        ]);
        return confirmation;
    }

    destroy_claim(claim) {
        console.log('[destroy_claim]');
        console.log(claim);
        loadingGif(loading, "hide", 500); // left here

        if (claim.flags.success) {

            claim.data.confirmation = this.claim_data_confirmation(claim.data);
            document.querySelector('div.display-form').classList.add('d-none');

            outputDiv.appendChild(this.claim_confirmation(claim.data));
            outputDiv.scrollIntoView({ behavior: "smooth" });

            if (claim.flags.method !== 'claimsPut') {
                setTimeout(() => {
                    modal(i18n.getTranslation('confirmation_screen_additional')['title'], i18n.getTranslation('confirmation_screen_additional')['body']);
                }, 250);
            }

        } else {
            modal(i18n.getTranslation('error'), i18n.getTranslation('claim_submit_error'));
        }

        // Loop thru each input and disable to prevent changes and resubmissions
        for (var type in claim.inputs) {
            if (claim.inputs[type] && claim.inputs[type].length > 0) {
                claim.inputs[type].forEach(function (field) {
                    field.disabled = true;
                });
            }
        }

        [].forEach.call(document.querySelectorAll('input[type="radio"]'), function (radio) {
            radio.setAttribute('disabled', 'disabled');
        });

        document.getElementById('submit-claim').setAttribute('disabled', 'disabled');
    }
}
